"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("../create-validator");
var messages_1 = require("../messages");
exports.requiredNumber = create_validator_1.createValidatorFactory(function (x) { return typeof x === "number" && isFinite(x); }, messages_1.REQUIRED_NUMBER);
